import { findIn } from '../../app/helpers/entity'
import {
  RENT_LENGTH_TYPES,
  SET_PRICING_PAYMENT_METHOD_TYPES,
  SET_PRICING_PAYMENT_METHOD_TYPES_LABELS
} from '../../app/core/constants'
import { isTvDip } from '../../app/helpers/fn'
import { checkCSIntersection, newItemPriceError, openCSModal } from './addChannelSet.controller'

/**
 * AddVodSetCtrl controller
 */

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

AddVodSetCtrl.mixes = [
  'openPopupCtrlMixin'
]

/**
 * AddVodSetCtrl controller
 *
 * @class AddVodSetCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages.
 * @mixes mwApp/common.mixin:openPopupCtrlMixin
 *
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddVodSetCtrl
 */
/* @ngInject */
export default function AddVodSetCtrl ($http, $scope, $location, $uibModal, VODSet, NetworkCurrency, alertLiteSvc, cs, pckg) {
  var vm = this

  /**
   * Vod Set
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   * @type {models.VODSet}
   */
  vm.vs = cs

  vm.set_pricing_payment_method_types = angular.copy(SET_PRICING_PAYMENT_METHOD_TYPES)
  vm.set_pricing_payment_method_types_labels = angular.copy(SET_PRICING_PAYMENT_METHOD_TYPES_LABELS)
  vm.types = Object.keys(vm.set_pricing_payment_method_types)
  if (window.ENV.APP_CS_PER_ITEM_ENABLED !== 'true') {
    vm.types = ['PER_SET']
  }

  /**
   *
   * @type {{[periodName:string]: string}}
   */
  vm.rentLengthTypes = RENT_LENGTH_TYPES

  /**
   * Network
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  vm.notTvDip = !isTvDip()

  /**
   * Currencies list
   *
   * @memberof mwApp/settings.controller:PaymentSystemCtrl
   * @name vm.currencies
   * @type {models.NetworkCurrency[]}
   */

  // load currencies
  NetworkCurrency.loadAll({ network: pckg })
    .then(data => data.filter(c => c.enabled))
    .to(vm.currencies = [])
    .then(() => {
      vm.vs.pricing.currency = vm.vs.pricing.currency
        ? findIn(vm.currencies)(vm.vs.pricing.currency)
        : vm.currencies[0]
    })
    .finally(() => { vm.extraLoaded = true })

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   * @type {Boolean}
   */
  vm.isNew = cs._isNew()

  /**
   * Filter value for vod sets
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   * @type {string}
   */
  vm.vodsFilter = ''

  /**
   * Filter value for assigned vod sets
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   * @type {string}
   */
  vm.assignedVodsFilter = ''

  /**
   * Vods arrays
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   * @type {Object}
   */
  vm.vods = {
    available: [],
    assigned: []
  }

  /**
   * Search content params with default values
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   * @type {Object}
   */
  vm.searchContentParams = {
    q: '',
    page: 0,
    last: false
  }

  // initialize params
  vm.searchContentAssignedParams = angular.copy(vm.searchContentParams)
  vm.searchContentAvailableParams = angular.copy(vm.searchContentParams)

  /**
   * Table state
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   * @type {Object[]}
   */
  vm.vodDefaultPagination = {
    'sort-by': 'id',
    'sort-order': 'asc',
    page: 0,
    count: 25,
    q: ''
  }

  vm.getAvailableVods = function () {
    vm.vs._getVodsAvailable({ q: vm.filter, page: 0 }).then((result) => {
      const content = angular.copy(result.content)
      vm.vs.$available = content.filter(c => !vm.vods.assigned.find(va => va.id === c.id))
      vm.vods.available = content.filter(c => !vm.vods.assigned.find(va => va.id === c.id))
      vm.searchContentAvailableParams.last = result.last
    })
  }

  // get vods lists
  const result = vm.vs._getVodsAvailable().then((result) => {
    const content = angular.copy(result.content)
    vm.vs.$available = content
    vm.vods.available = content
    vm.searchContentAvailableParams.last = result.last
  })

  if (!vm.isNew) {
    result.then(() => {
      vm.vs._getVodsAssigned().then((result) => {
        const content = angular.copy(result.content)
        vm.vs.$assigned = content // store original data
        vm.vods.assigned = content
        vm.searchContentAssignedParams.last = result.last
      })
    })
  }

  /**
   * Handler for scroll event of Available select list
   *
   * @param event
   */
  vm.$timerContentAvailableScroll = 0
  vm.contentCallbackAvailableScroll = (event) => {
    const {
      page,
      last
    } = vm.searchContentAvailableParams
    if (!last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerContentAvailableScroll)
      vm.$timerContentAvailableScroll = window.setTimeout(() => {
        vm.vs._getVodsAvailable({
          page: page + 1,
          q: vm.filter
        }).then((result) => {
          const content = angular.copy(result.content)
          vm.searchContentAvailableParams.last = result.last
          vm.vods.available = vm.vods.available.concat(content.filter(c => !vm.vods.assigned.find(va => va.id === c.id)))
          vm.vs.$available = vm.vs.$available.concat(content.filter(c => !vm.vods.assigned.find(va => va.id === c.id)))
          vm.searchContentAvailableParams.page = result.number
        })
      }, 700)
    }
  }

  /**
   * Handler for scroll event of Assigned select list
   *
   * @param event
   */
  vm.$timerContentAssignedScroll = 0
  vm.contentCallbackAssignedScroll = (event) => {
    const {
      page,
      last
    } = vm.searchContentAssignedParams
    if (!vm.isNew && !last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerContentAssignedScroll)
      vm.$timerContentAssignedScroll = window.setTimeout(() => {
        vm.vs._getVodsAssigned({
          page: page + 1
        }).then((result) => {
          const content = angular.copy(result.content)
          vm.searchContentAssignedParams.last = result.last
          vm.vods.assigned = vm.vods.assigned.concat(content)
          vm.vs.$assigned = vm.vs.$assigned.concat(content)
          vm.searchContentAssignedParams.page = result.number
        })
      }, 700)
    }
  }

  /**
   * Save VODSet function
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   */
  vm.saveSet = function () {
    vm.setDisable()
    cs._save((data) => {
      data.vodIdsToAssign = vm.vods.assigned.map((av) => {
        return cs.$assigned.find(($av) => $av.id === av.id) ? null : av.id
      }).filter(Boolean)

      data.vodIdsToRemove = cs.$assigned.map((av) => {
        return vm.vods.assigned.find(($av) => $av.id === av.id) ? null : av.id
      }).filter(Boolean)
    })
      .then((res) => {
        cs._update().then(() => {
          if (vm.isNew) {
            $location.url(cs._publicListUrl + res.data.payload.id)
          }
        })
      })
      .then(vm.location(cs).reload)
      .finally(vm.unsetDisable)
  }

  /**
   * Create or edit coupon, and close modal window afterwards
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   */
  vm.submit = function () {
    if (vm.vods.assigned.length === 0 || (!vm.vs.$buyEnabled && !vm.vs.$rentEnabled)) {
      return
    }
    vm.checkIntersection()
      .then(
        () => {
          newItemPriceError($uibModal, cs, cs.assignedSubscriptions, vm.vods.assigned, cs.$assigned.map(a => a.id))
            .then(() => { vm.saveSet() })
        })
  }

  // see http://marceljuenemann.github.io/angular-drag-and-drop-lists/demo/#/multi

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, type, items, index) {
    $scope.form.$setDirty()
    items.forEach(item => { item.selected = false })
    list[type] = list[type]
      .slice(0, index)
      .concat(items)
      .concat(list[type].slice(index))
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, type, link) {
    link.selected = true
    return list[type].filter(link => link.selected)
  }
  /**
   * Delete Vod from vodSet
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   */
  vm.deleteVodFromSet = function (link) {
    link.selected = false
    vm.vods.assigned = vm.vods.assigned.filter(vod => vod.id !== link.id)
    vm.vods.available.push(link)
    vm.checkIntersection(true)
    $scope.form.$setDirty()
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.dragging = false
    vm.checkIntersection()
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list, type) {
    list[type] = list[type].filter(item => !item.selected)
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   */
  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(vm.pckg._publicUrl + '/contentSets')
    }
  }

  /**
   * Filter assigned vods
   *
   * @param {VODSet} vod
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   */
  $scope.filteredAssignedVods = (vod) =>
    vm.assignedVodsFilter.length > 0
      ? vod.name.toLowerCase().includes(vm.assignedVodsFilter.toLowerCase())
      : true

  vm.openConflicts = function (item) {
    event.stopPropagation()
    openCSModal($uibModal, vm.vs, item, vm.checkIntersection)
  }

  vm.checkIntersection = function (checkOnDelete = false) {
    if (checkOnDelete && !vm.hasCSintersection) { return }
    vm.setDisable()
    return checkCSIntersection($http, alertLiteSvc, vm.vs, vm.vods.assigned, vm.isNew)
      .then(data => { vm.hasCSintersection = data })
      .finally(vm.unsetDisable)
  }
}
